import api from './api';

const companyService = {
  // Get company details for logged-in user
  getCompanyDetails: async () => {
    try {
      const response = await api.get('/companies/my-company');
      return response.data;
    } catch (error) {
      console.error('Error fetching company details:', error);
      throw error;
    }
  },

  // Get all companies
  getAllCompanies: async () => {
    try {
      const response = await api.get('/companies');
      return response.data;
    } catch (error) {
      console.error('Error fetching all companies:', error);
      throw error;
    }
  },

  // Update company details
  updateCompanyDetails: async (companyData) => {
    try {
      const response = await api.put('/users/company', companyData);
      return response.data;
    } catch (error) {
      console.error('Error updating company details:', error);
      throw error;
    }
  }
};

export default companyService;
